import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import {
  LoginContainer,
  LeftSection,
  RightSection,
  LogoContainer,
  LogoBadge,
  MainTitle,
  SubtitleText,
  RightContent,
  CardBox,
  CardIcon,
  CardTitle,
  CardDescription,
  LoginButton,
  Footer,
} from "./login.styled";
import Languages from "../layouts/commons/header/components/languages";

const LoginForm = (props) => {
  const { gotoLogin } = props;
  const { t } = useTranslation();

  return (
    <LoginContainer>
      {/* Left Section */}
      <LeftSection>
        <svg
          style={{
            position: "absolute",
            top: "20%",
            right: "-10%",
            width: "500px",
            height: "500px",
            opacity: 0.1,
            zIndex: 0,
          }}
          viewBox="0 0 500 500"
        >
          <circle
            cx="250"
            cy="250"
            r="200"
            stroke="white"
            strokeWidth="2"
            fill="none"
          />
          <circle
            cx="250"
            cy="250"
            r="150"
            stroke="white"
            strokeWidth="1.5"
            fill="none"
          />
          <circle
            cx="250"
            cy="250"
            r="100"
            stroke="white"
            strokeWidth="1"
            fill="none"
          />
        </svg>

        <LogoContainer>
          <LogoBadge>
            <span>🛡️</span>
            <span className="badge-text">
              {t("loginPage.badge_text") || "Gestión de Formación en Seguridad"}
            </span>
          </LogoBadge>
        </LogoContainer>

        <MainTitle>ASSISTA</MainTitle>
        <SubtitleText>
          {t("loginPage.subtitle") ||
            "Empower your team with modern workplace safety education and compliance tracking."}
        </SubtitleText>

        {/* <FeatureList>
          <FeatureItem>
            <span className="check">✓</span>
            <span className="feature-text">
              {t("loginPage.certified") || "Certified Training"}
            </span>
          </FeatureItem>
          <FeatureItem>
            <span className="check">✓</span>
            <span className="feature-text">
              {t("loginPage.realtime") || "Real-time Tracking"}
            </span>
          </FeatureItem>
          <FeatureItem>
            <span className="check">✓</span>
            <span className="feature-text">
              {t("loginPage.compliance") || "Compliance Ready"}
            </span>
          </FeatureItem>
        </FeatureList> */}

        <Footer>
          <img
            src="/assets/images/logo.png"
            alt="De Prado Logo"
            style={{
              height: "40px",
              width: "auto",
              opacity: 0.8,
            }}
          />
        </Footer>
      </LeftSection>

      {/* Right Section */}
      <RightSection>
        <div className="language-selector">
          <Languages />
        </div>

        <RightContent>
          <h1 className="welcome-title">
            {t("loginPage.welcome_back") || "Bienvenido"}
          </h1>
          <p className="welcome-subtitle">
            {t("loginPage.signin_subtitle") ||
              "Sign in to continue your training"}
          </p>

          <CardBox>
            <CardIcon>⚡</CardIcon>
            <CardTitle>
              {t("loginPage.corporate_login") || "Corporate Login"}
            </CardTitle>
            <CardDescription>
              {t("loginPage.card_description") ||
                "You'll be securely redirected to your company's authentication portal"}
            </CardDescription>

            <LoginButton onClick={() => gotoLogin()}>
              {t("login")} →
            </LoginButton>
            {/* <SecurityBadge> */}
            <CardDescription>
              <span className="icon">🔒</span>
              {t("loginPage.security") || "Secure SSO Authentication"}
            </CardDescription>
            {/* </SecurityBadge> */}

            <p className="help-text">
              {t("loginPage.need_help") ||
                "Need help? Contact your system administrator"}
            </p>
          </CardBox>
        </RightContent>
      </RightSection>
    </LoginContainer>
  );
};

LoginForm.propTypes = {
  gotoLogin: PropTypes.func,
};

export default LoginForm;
